var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVacinas(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6541_2271",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6541_2271)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.9 11.1781C3.71667 10.9781 3.625 10.7406 3.625 10.4656C3.625 10.1906 3.71667 9.95312 3.9 9.75313L6.7 6.95312L5.625 5.87812L5.325 6.17813C5.125 6.37813 4.8875 6.47813 4.6125 6.47813C4.3375 6.47813 4.1 6.37813 3.9 6.17813C3.71667 5.99479 3.625 5.76146 3.625 5.47813C3.625 5.19479 3.71667 4.96146 3.9 4.77813L5.9 2.77813C6.1 2.57813 6.3375 2.47813 6.6125 2.47813C6.8875 2.47813 7.125 2.57813 7.325 2.77813C7.50833 2.96146 7.6 3.19479 7.6 3.47812C7.6 3.76146 7.50833 3.99479 7.325 4.17813L7.025 4.47813L8.1 5.55313L10.9 2.75313C11.1 2.55313 11.3375 2.45312 11.6125 2.45312C11.8875 2.45312 12.125 2.55313 12.325 2.75313C12.525 2.95312 12.625 3.19063 12.625 3.46563C12.625 3.74063 12.525 3.97812 12.325 4.17813L11.65 4.82812L19.025 12.2031C19.4083 12.5865 19.6 13.0573 19.6 13.6156C19.6 14.174 19.4083 14.6448 19.025 15.0281L18.325 15.7531L23.05 20.4531H20.2L16.9 17.1531L16.2 17.8781C15.8167 18.2615 15.3458 18.4531 14.7875 18.4531C14.2292 18.4531 13.7583 18.2615 13.375 17.8781L6 10.5031L5.325 11.1781C5.125 11.3615 4.8875 11.4531 4.6125 11.4531C4.3375 11.4531 4.1 11.3615 3.9 11.1781ZM7.4 9.10313L14.775 16.4781L17.6 13.6281L16.1 12.1031L14.7 13.5031C14.5 13.6865 14.2625 13.7823 13.9875 13.7906C13.7125 13.799 13.4833 13.7115 13.3 13.5281C13.1 13.3281 13 13.0906 13 12.8156C13 12.5406 13.1 12.3031 13.3 12.1031L14.7 10.7031L13.2 9.20312L11.8 10.6031C11.6 10.7865 11.3625 10.8781 11.0875 10.8781C10.8125 10.8781 10.575 10.7865 10.375 10.6031C10.1917 10.4031 10.1 10.1656 10.1 9.89062C10.1 9.61562 10.1917 9.37812 10.375 9.17812L11.775 7.77813L10.25 6.25312L7.4 9.10313Z",
    fill: "#263E6C"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVacinas);
export default __webpack_public_path__ + "static/media/vacinas.4cc4a89fab0bd6910e5f532cb6dc19a2.svg";
export { ForwardRef as ReactComponent };